import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import Lottie from 'react-lottie';
import ThumbsUpAnimation from '../../../../../../animations/like-thumb-up-outline.json';
import Checkbox from '../../../../../Shared/CheckBox/Checkbox';

const SuccessMsg = (props) => {

  /*
  function openTermsInNewTab(e) {
    e.preventDefault();
    window.open(props.termsLink, '_blank').focus();
  }
  */

  return (
    <div className='payment-cg-success-msg'>
      <div className='img-wrapper'>
        <Image alt="icon-like" src={require('../images/icon-like.svg')} />
      </div>
      <div className='text-wrapper'>
        <p>הכרטיס מאושר</p>
      </div>
    </div>
  );
};

export default SuccessMsg;
